import React from 'react'
import { Helmet } from 'react-helmet-async';
import HeaderSix from "../components/header/HeaderSix";
import BannerSix from "../components/banner/BannerSix";
import ServiceSix from "../components/service/ServiceSix";
import CounterupFour from "../components/counterup/CounterupFour";
import AboutFour from "../components/about/AboutFour";
import ProgressCircle from "../components/counterup/ProgressCircle";
// import TeamFour from "../components/team/TeamFour";
// import BusinessGroth from "../components/businessgoal/BusinessGroth";
import WorkingProcessThree from "../components/workingprocess/WorkingProcessThree";
import TechnologyPartners from "../components/brand/TechnologyPartners";
// import GalleryTwo from "../components/gallery/GalleryTwo";
// import BrandOne from "../components/brand/BrandOne";
// import TestimonialFive from "../components/testimonials/TestimonialFive";
// import BlogSix from "../components/blog/BlogSix";




import FooterOne from "../components/footer/FooterOne";

function HomeOne() {
    const schemaData = {
        "@context": "https://schema.org",
        "@graph": [
            {
                "@type": ["LocalBusiness","AccountingService"],
                "@id": "https://www.aviteusbusiness.co.uk/#business",
                "name": "Aviteus Business Solutions",
                "url": "https://www.aviteusbusiness.co.uk/",
                "image": "https://www.aviteusbusiness.co.uk/assets/office.jpg",
                "logo": "https://www.aviteusbusiness.co.uk/assets/logo.png",
                "telephone": "+44 20 4628 8209",
                "email": "info@aviteusbusiness.co.uk",
                "priceRange": "££",
                "address": {
                    "@type": "PostalAddress",
                    "streetAddress": "Alpha House, 296 Kenton Rd",
                    "addressLocality": "Harrow",
                    "postalCode": "HA3 8DD",
                    "addressCountry": "GB"
                },
                "areaServed": [
                    {"@type": "Country","name": "United Kingdom"}
                ],
                "openingHoursSpecification": [{
                    "@type": "OpeningHoursSpecification",
                    "dayOfWeek": ["Monday","Tuesday","Wednesday","Thursday","Friday"],
                    "opens": "09:00",
                    "closes": "17:00"
                }],
                "knowsAbout": [
                    "SME accounting","Payroll","VAT returns","Corporate tax",
                    "Self assessment","Management accounts","Company formation",
                    "Making Tax Digital","Xero","Sage","QuickBooks"
                ],
                "parentOrganization": {"@id": "https://www.aviteusbusiness.co.uk/#org"}
            },
            {
                "@type": "WebSite",
                "@id": "https://www.aviteusbusiness.co.uk/#website",
                "url": "https://www.aviteusbusiness.co.uk/",
                "name": "Aviteus Business Solutions",
                "publisher": {"@id": "https://www.aviteusbusiness.co.uk/#org"},
                "potentialAction": {
                    "@type": "SearchAction",
                    "target": "https://www.aviteusbusiness.co.uk/search?q={search_term_string}",
                    "query-input": "required name=search_term_string"
                },
                "inLanguage": "en-GB"
            },
            {
                "@type": "WebPage",
                "@id": "https://www.aviteusbusiness.co.uk/#webpage",
                "url": "https://www.aviteusbusiness.co.uk/",
                "name": "Trusted Accountants for Growing Businesses Across the United Kingdom",
                "isPartOf": {"@id": "https://www.aviteusbusiness.co.uk/#website"},
                "about": {"@id": "https://www.aviteusbusiness.co.uk/#business"},
                "description": "UK-wide chartered accountants for SMEs and startups. Bookkeeping, payroll, VAT, tax and advisory with fixed pricing and clear advice.",
                "inLanguage": "en-GB"
            },
            {
                "@type": "BreadcrumbList",
                "@id": "https://www.aviteusbusiness.co.uk/#breadcrumbs",
                "itemListElement": [
                    {"@type":"ListItem","position":1,"name":"Home","item":"https://www.aviteusbusiness.co.uk/"}
                ]
            }
        ]
    };

    return (
        <div className='index-six'>
            <Helmet>
                <title>Accountants for UK SMEs | Aviteus Business Solutions</title>
                <meta name="description" content="UK-wide chartered accountants for SMEs and startups. Bookkeeping, payroll, VAT, tax and advisory with fixed pricing and clear advice. Book a free consultation." />
                <link rel="canonical" href="https://www.aviteusbusiness.co.uk/" />
                <script type="application/ld+json">
                    {JSON.stringify(schemaData)}
                </script>
            </Helmet>

            <HeaderSix />
            <BannerSix />
            <ServiceSix />
            <CounterupFour />
            <AboutFour />
            <ProgressCircle />
            {/* <TeamFour /> */}
            {/* <BusinessGroth /> */}
            <WorkingProcessThree />
            <TechnologyPartners />
            {/* <GalleryTwo /> */}
            {/* <BrandOne /> */}
            {/* <TestimonialFive /> */}
            {/* %logo-3.svg */}

            <FooterOne />

        </div>
    )
}

export default HomeOne